import React from 'react';
import fallbackLogo from '../../images/logo.png';
import {
  AppSettingsContext,
  resolveBrandingLogo,
  resolveAppDisplayTitle,
} from '../../contexts/AppSettingsProvider';
import { getPreferredTheme } from '../../services/themeService';

export default function BrandingLogo({ className, style, colorTheme, maxHeight }) {
  const imgStyle = maxHeight != null ? { maxHeight, ...style } : style;

  return (
    <AppSettingsContext.Consumer>
      {(settings) => {
        const theme = colorTheme || getPreferredTheme();
        const title = resolveAppDisplayTitle(settings);
        const src = resolveBrandingLogo(settings?.branding, theme) || fallbackLogo;
        return (
          <img
            src={src}
            alt={title}
            className={className}
            style={imgStyle}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackLogo;
            }}
          />
        );
      }}
    </AppSettingsContext.Consumer>
  );
}
